module.exports = __webpack_public_path__ + "static/img/David-Armstrong.bcf607b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Armstrong.jpg
// module id = +V/5
// module chunks = 0